import { Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nService } from '../../services/i18n.service';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  selector: 'app-htst-color-code',
  imports: [CommonModule, FormsModule, NzRadioModule],
  templateUrl: './htst-color-code.html',
  styleUrls: ['./htst-color-code.scss'],
})
export class HtstColorCodeComponent {
  colorInput = input<any[]>([]);
  colorCode = output<any>();
  radioValue = signal<string>('');
  public i18n = inject(I18nService);

  getSelectedColor(color: any) {
    this.radioValue.set(color.ColourCodeHex);
    this.colorCode.emit(color);
  }
}
